import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: new Array(_ctx.rows),
      stripedRows: "",
      showGridlines: "",
      responsiveLayout: "scroll"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (el) => {
          return (_openBlock(), _createBlock(_component_Column, { key: el }, {
            header: _withCtx(() => [
              _createVNode(_component_Skeleton, _mergeProps({ ref_for: true }, { width: '100%' }), null, 16)
            ]),
            body: _withCtx(() => [
              _createVNode(_component_Skeleton, _mergeProps({ ref_for: true }, { width: '75%' }), null, 16)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}